// extracted by mini-css-extract-plugin
export default {"list":"List_list__AK7hC","listItem":"List_listItem__rc4Wj"};